import React from "react";
import classNames from "classnames";
import SingleProductPageTableCell from "components/SingleProductPage/SingleProductPageTableCell";
import "react-tooltip/dist/react-tooltip.css";
import { useTranslation } from "react-i18next";
import { isArray, isEmptyString } from "utils/types/typeguards";

type Props = {
	productTextId: string
}

function SingleProductPageTable({
	productTextId,
}: Props) {

	const cellStyles = "text-white border-emerald-500 text-sm sm:text-base md:text-lg xs:text-sm leading-loes p-[17px]";

	const { t } = useTranslation();
	const table = t([ `products.${ productTextId }.table`, "", ], { returnObjects: true });
	const title = t([`products.${ productTextId }.table.title`, ""]);
	const bottomText = t([`products.${ productTextId }.table.bottomText`, ""]);

	const elements = t([ `products.${ productTextId }.table.tableContent`, "", ], { returnObjects: true }) as string[][] | string;
	const titles = isArray(elements) ? elements[ 0 ] : [];
	const columns = isArray(elements) ? elements.slice(1, elements.length) : [];
	const hasAnyElements = () => !isEmptyString(table);

	if (!hasAnyElements()) return <></>

	return (
		<div className="container">
			<div className="mt-14">
				<div className="p-7 lg:p-14 bg-gradient-to-br from-blue-900 via-blue-700 to-sky-400 rounded-3xl flex-col justify-start items-center gap-10 flex">
					<h2 className="text-center text-white font-medium leading-10">
						{ title }
					</h2>
					<div className="max-w-[100%] overflow-x-auto">
						<div  style={ { minWidth: (columns.length + 1) * 250 } }>
							<div className="grid" style={ { gridTemplateColumns: `repeat(${ columns.length + 1 }, minmax(0, auto)` } }>
								<div className="flex flex-col">
									{
										titles.map((title, index) =>
											<div
												key={ index }
												className={ classNames(
													cellStyles,
													`font-bold${ index !== titles.length - 1 ? " border-b-2" : "" }`
												) }
											>
												{ title }
											</div>
										)
									}
								</div>
								{
									columns.map((column, columnIndex) =>
										<div className="flex flex-col" key={ columnIndex }>
											{
												column.map((cell, cellIndex) =>
													<SingleProductPageTableCell
														className={ classNames(cellStyles, `whitespace-nowrap overflow-ellipsis overflow-hidden border-l-2${ cellIndex === 0 ? " font-bold" : "" }${ cellIndex !== titles.length - 1 ? " border-b-2" : "" }`) }
														tooltipId={ `tooltip-id-${ cellIndex }-${ cell.trim() }` }
													>
														{ cell }
													</SingleProductPageTableCell>
												)
											}
										</div>
									)
								}
							</div>
						</div>
					</div>
					<div className="text-white text-sm sm:text-base font-light w-[100%]">
						{ bottomText }
					</div>
				</div>
			</div>
		</div>
	);
}

export default SingleProductPageTable;